import React, { useCallback, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { StandardGrid } from '../../Grid';
import { getStreamItemId } from '../../Duperbrowse/redux/helpers';
import StandardThumb from '../../DeviationViews/Thumb/Standard';
import MobileThumb, { EXTRAS_HEIGHT as MOBILE_EXTRAS_HEIGHT } from '../../DeviationViews/Thumb/Mobile';
const DeviationGrid = ({ items, adjustHeight, cookieType, contentStrip, contentStripIndex, contentStripHeight, enableScrollOptim, spacing, allowMobileCard: allowMobileCardProp, adAfterNRow, adRenderer })=>{
    const isMobile = useContext(MobileContext);
    const allowMobileCard = allowMobileCardProp && isMobile;
    const getGridItemId = useCallback((index)=>{
        const item = items[index];
        return `item-${item.typeId}-${item.deviationId}`;
    }, [
        items
    ]);
    const getDuperbrowseItemId = useCallback((index)=>{
        return getStreamItemId(items[index]);
    }, [
        items
    ]);
    const renderGridItem = useCallback((element)=>{
        const { index, width, height, style } = element;
        const item = items[index];
        if (!item) {
            return;
        }
        if (allowMobileCard) {
            return /*#__PURE__*/ React.createElement(MobileThumb, {
                key: getGridItemId(index),
                deviation: item,
                width: width,
                height: height,
                style: style
            });
        }
        return /*#__PURE__*/ React.createElement(StandardThumb, {
            key: getGridItemId(index),
            deviation: item,
            width: width,
            height: height,
            style: style
        });
    }, [
        getGridItemId,
        items,
        allowMobileCard
    ]);
    return /*#__PURE__*/ React.createElement(StandardGrid, {
        contentStrip: contentStrip,
        contentStripIndex: contentStripIndex,
        contentStripHeight: contentStripHeight,
        elementCount: items.length,
        cookieType: cookieType,
        getElementId: getGridItemId,
        getDuperbrowseItemId: getDuperbrowseItemId,
        adjustHeight: allowMobileCard ? MOBILE_EXTRAS_HEIGHT + (adjustHeight !== null && adjustHeight !== void 0 ? adjustHeight : 0) : adjustHeight,
        enableScrollOptim: enableScrollOptim,
        spacing: spacing,
        adAfterNRow: adAfterNRow,
        adRenderer: adRenderer
    }, renderGridItem);
};
DeviationGrid.displayName = 'DeviationGrid';
export default DeviationGrid;
